export default "__VITE_ASSET__bd993651__"